module.exports = __webpack_public_path__ + "assets/img/05b.83dd30f4.png";